import React from 'react';
import { FaHeart, FaPlay, FaGraduationCap, FaHome, FaHandsHelping } from 'react-icons/fa';
import heroImage from '../gallaries/MRB_96.JPG';

const Hero = () => {
  return (
    <section id="home" className="hero hero-design1">
      <div className="container hero-content">
        <div className="hero-left">
          <div className="hero-badge">
            <FaHeart />
            <span>Making a Difference</span>
          </div>
          <h1>
            <span className="hero-highlight">Nengai</span> 
            <span className="hero-main">Foundation</span>
          </h1>
          <div className="moto">
            <span className="moto-part">Spread Love</span>
            <span className="moto-divider">&</span>
            <span className="moto-part">Spread Hope</span>
          </div>
          <p>Empowering children with autism in the Maasai community to reach their full potential through love, care, and dedicated support.</p>
          <div className="hero-buttons">
            <a href="#donate" className="btn btn-primary">
              <FaHeart />
              Donate Now
            </a>
            <a href="#about" className="btn btn-secondary">
              <FaPlay />
              Our Story
            </a>
          </div>
          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-number">30+</span>
              <span className="stat-label">Children Helped</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">3</span>
              <span className="stat-label">Years Active</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">Dedication</span>
            </div>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-image-container">
            <div className="floating-card card-1">
              <FaGraduationCap />
              <span>Education</span>
            </div>
            <div className="floating-card card-2">
              <FaHome />
              <span>Housing</span>
            </div>
            <div className="floating-card card-3">
              <FaHandsHelping />
              <span>Support</span>
            </div>
            <img src={heroImage} alt="Maasai community children" />
          </div>
        </div>
      </div>
      <div className="hero-decoration">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
        <div className="decoration-circle circle-3"></div>
      </div>
    </section>
  );
};

export default Hero;